/* Publishes the header's live height as --header-height-current.

   The theme's --header-height is written once from the section settings and
   corrected on resize. It is the header's FULL height and stays at that value
   while the header is shrunk, which is correct for everything that reserves
   space for the header (the backfill spacer in particular, which must not move
   or the page would jump the moment the header sticks).

   What it is wrong for is anything sized to sit INSIDE the shrunken header -
   the search bar, and the dropdown's max-height cap. Those read this variable
   instead. A ResizeObserver rather than a hardcoded number, so it stays right
   if the padding, the logo or the nav font size ever change. */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-header-height]');
    if (!header || !('ResizeObserver' in window)) return;

    var last = null;
    new ResizeObserver(function (entries) {
      var h = Math.round(entries[0].contentRect.height);
      if (h === last || !h) return;
      last = h;
      document.documentElement.style.setProperty('--header-height-current', h + 'px');
    }).observe(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The header is a section: the editor re-renders it rather than reloading.
  document.addEventListener('shopify:section:load', init);
})();
